import setup from "./setup";
setup();

import makeChart from "./scatter-change";
import theData from "../data/data.json";

function main() {

  const theChart = new makeChart({
    element: document.querySelector(".chart"),
    data: theData
  })

  window.addEventListener("optimizedResize", () => {
    theChart.update();
  });

}

window.onload = main;
